import styled from 'styled-components';

interface CarouselControlIconStyledProps {
    hasNext?: boolean;
    prev?: boolean;
}

export const CarouselControlIconWrapperStyled = styled.div<CarouselControlIconStyledProps>`
    display: inline-block;
    bottom: 0;
    ${({ prev }) => (prev ? 'left: 0;' : 'right: 0;')}
    position: absolute;
    z-index: 2;

    ${({ hasNext }) => (hasNext ? 'cursor: pointer;' : '')}
    svg {
        fill: var(${({ hasNext }) => (hasNext ? '--color-yellow' : '--color-purple-highlight')});

        &:hover {
            ${({ hasNext }) => (hasNext ? 'fill: var(--color-yellow-light);' : '')}
        }
    }
`;
